import AccountBalanceIcon from '@material-ui/icons/AccountBalance';

import List from './List';

export default {
  list: List,
  icon: AccountBalanceIcon,
};
